import Ajv from "ajv";
import SMART_SEARCH from '../../node_modules/smart-search/package.json';

const ajv = new Ajv({
  useDefaults: true,
  allErrors: true,
  jsonPointers: true
});

class ValidationService {
  validators = {}

  init = () => {
    if(SMART_SEARCH["app-framework"] && SMART_SEARCH["app-framework"]["actions"]) {
      this.validators = {
        ...this.validators,
        ...Object.fromEntries(Object.entries(SMART_SEARCH["app-framework"]["actions"])
        .map(([name, value]) => [`@smart-search/${name}`, ajv.compile(value)]))
      };
    }
  };

  validateable = (action) => this.validators[action.type]

  validate = async (action) => this.validators[action.type](action.payload)
}

const inst = new ValidationService();
inst.init();
export default inst;
